const actionTypes = {
    REQUEST_UPCOMING_PUBLICATIONS: 'REQUEST_UPCOMING_PUBLICATIONS',
    RECEIVE_UPCOMING_PUBLICATIONS_SUCCESS: 'RECEIVE_UPCOMING_PUBLICATIONS_SUCCESS',
    RECEIVE_UPCOMING_PUBLICATIONS_FAILURE: 'RECEIVE_UPCOMING_PUBLICATIONS_FAILURE',

    REQUEST_UPCOMING_PUBLICATION_FILTERS: 'REQUEST_UPCOMING_PUBLICATION_FILTERS',
    RECEIVE_UPCOMING_PUBLICATION_FILTERS_SUCCESS: 'RECEIVE_UPCOMING_PUBLICATION_FILTERS_SUCCESS',
    RECEIVE_UPCOMING_PUBLICATION_FILTERS_ERROR: 'RECEIVE_UPCOMING_PUBLICATION_FILTERS_ERROR',

    EXPORT_UPCOMING_PUBLICATIONS: 'EXPORT_UPCOMING_PUBLICATIONS',
    EXPORT_UPCOMING_PUBLICATIONS_SUCCESS: 'EXPORT_UPCOMING_PUBLICATIONS_SUCCESS',
    EXPORT_UPCOMING_PUBLICATIONS_FAILURE: 'EXPORT_UPCOMING_PUBLICATIONS_FAILURE'
};

export default actionTypes;